import {ProductCategory, ReportSummary, type TabLabel} from "@/ReactInit/Scripts/DashboardPage/types";
import {parseDashboardDate} from "@/ReactInit/Scripts/DashboardPage/utils/dashboardFormatting";

export const tabParamToLabel = (param: string | null): TabLabel => {
  switch (param) {
    case "users":
      return "Brukeradministrasjon";
    case "reports":
    default:
      return "Rapportoversikt";
  }
};

export const tabLabelToParam = (tab: TabLabel): string =>
  tab === "Brukeradministrasjon" ? "users" : "reports";

export const reportSortParamToLabel = (param: string | null): string => {
  switch (param) {
    case "eldste":
      return "Eldste";
    case "alfabetisk":
      return "Alfabetisk";
    case "nyeste":
    default:
      return "Nyeste";
  }
};

export const reportSortLabelToParam = (label: string): string => {
  switch (label) {
    case "Eldste":
      return "eldste";
    case "Alfabetisk":
      return "alfabetisk";
    case "Nyeste":
    default:
      return "nyeste";
  }
};

export const userSortParamToLabel = (param: string | null): string => {
  switch (param) {
    case "oldest":
      return "Eldste";
    case "alpha":
      return "Alfabetisk";
    case "newest":
    default:
      return "Nyeste";
  }
};

export const userSortLabelToParam = (label: string): string => {
  switch (label) {
    case "Eldste":
      return "oldest";
    case "Alfabetisk":
      return "alpha";
    case "Nyeste":
    default:
      return "newest";
  }
};

export const cn = (...classes: Array<string | undefined | false | null>) =>
  classes.filter(Boolean).join(" ");

export const normalizeId = (id?: string | null) => {
  const s = (id ?? "").trim();
  return s.length ? s : null;
};

export const normalizeProductKey = (name: string) => name.trim().toLowerCase();

export const getDisabledCategoriesForIndex = (categories: Array<string | null | undefined>, selfIndex: number) => {
  return categories.filter((c, i): c is string => i !== selfIndex && typeof c === "string" && c.trim().length > 0);
};

export const buildCategoryByProductMap = (cats: ProductCategory[]) => {
  const map = new Map<string, string>();

  (cats ?? []).forEach((cat) => {
    Object.keys(cat.products ?? {}).forEach((productName) => {
      const key = normalizeProductKey(productName);
      if (!key) return;
      if (!map.has(key)) map.set(key, cat.category);
    });
  });

  return map;
};

export const getCategoryForProductName = (
  productName: string,
  categoryByProduct: Map<string, string>,
): string => {
  const key = normalizeProductKey(productName ?? "");
  return categoryByProduct.get(key) ?? "Ukjent kategori";
};

export const isReportSentToFabric = (r: ReportSummary): boolean => {
  const reportDt = parseDashboardDate(r.reportDate);
  const publishDt = parseDashboardDate(r.publishDate);

  const sentByDates =
    !!publishDt && (!reportDt || publishDt.getTime() > reportDt.getTime());

  return sentByDates || !!r.published;
};

export const formatNumberForDisplay = (
  value: string | number | null | undefined
) => {
  if (value == null || value === "") return "—";
  const raw = typeof value === "number" ? value.toString() : value.replace(/\s/g, "");
  const withSpaces = raw.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return `${withSpaces} kg`;
};